/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ViewAdminWrapper } from "../../components/ManageAdmin/style";
import {
    Heading,
    IconInactive,
    TableWarpper,
    Text,
    IconView,
    ButtonSolid
} from "../../components/styledConstants";
import FilterBox from "../../components/common/FilterBox";
import Pagination from "../../components/common/Pagination";
import ItemPerPage from "../../components/common/ItemPerPage";
import TableLoader from "../../components/common/TableLoader";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import IconActive from "../../assets/images/IconActive";
import CsvDown from "../../components/ExportFiles/CsvDown";
import PdfDown from "../../components/ExportFiles/PdfDown";
import { BlockPayInWrapper } from "../../components/MerchantDetail/PaymentSettings/style";
import SuccessMessage from "../../components/SuccessMessage";
import ErrorMessage from "../../components/ErrorMessage";
import { FilterWrapper } from "../Merchants/style";
import config from "../../utils/config";

const filterForm = [
    {
        name: "entity",
        type: "text",
        placeholder: "Org",
        value: "",
    },
    {
        name: "provider",
        type: "text",
        placeholder: "Provider",
        value: "",
    },
    {
        name: "transactionType",
        type: "text",
        placeholder: "Transaction Type",
        value: "",
    },
    {
        name: "paymentMode",
        type: "text",
        placeholder: "Payment Mode",
        value: "",
    },
    {
        name: "status",
        type: "select",
        placeholder: "Status",
        value: "",
        options: [
            { value: "", label: "All" },
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
        ],
    },
];

export default function TransactionCharges() {
    const [controls, setControls] = useState([...filterForm]);
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [message, setMessage] = useState({ success: "", error: "" });
    const [activeTab, setActiveTab] = useState("ORG");

    const labelMap = {
        ORG: "Org",
        BANK: "Bank",
        PG: "PG",
        ROLE: "Role"
    };

    const dynamicFilters = controls.map((filter) =>
        filter.name === "entity"
            ? { ...filter, placeholder: labelMap[activeTab] }
            : filter
    );

    const getPdfBody = (data) =>
        data.map((item) => {
            const obj = {};

            getColumnConfig()
                .filter(col => col.key !== "action")
                .forEach((col) => {
                    switch (col.key) {
                        case "chargeValue":
                            obj[col.key] =
                                item?.chargeType === "PERCENTAGE"
                                    ? `${item?.chargeValue}%`
                                    : `${item?.chargeValue ?? 0}`;
                            break;

                        case "gst":
                            obj[col.key] = item?.gstApplicable
                                ? item?.gstType === "PERCENTAGE"
                                    ? `${item?.gstValue}%`
                                    : `${item?.gstValue ?? 0}`
                                : "No GST";
                            break;

                        case "createdAt":
                            obj[col.key] = item?.createdAt
                                ? item.createdAt.split("T")[0]
                                : "-";
                            break;

                        default:
                            obj[col.key] = item?.[col.key] ?? "-";
                    }
                });

            return obj;
        });

    const renderStatus = (data) => {
        const status = data?.toLowerCase();
        switch (status) {
            case "active":
                return (
                    <div className="flex flex-center">
                        <IconActive width="13" className="align-top mr6" color="#2AC940" />
                        <Text size="xsm" fw="medium" color="color10">
                            {data}
                        </Text>
                    </div>
                );
            case "inactive":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" />
                        <Text size="xsm" fw="medium" color="color4">
                            {data}
                        </Text>
                    </div>
                );
            case "unverified":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" />
                        <Text size="xsm" fw="medium" color="color4">
                            {data}
                        </Text>
                    </div>
                );
            case "suspended":
                return (
                    <div className="flex flex-center">
                        <IconInactive width="12px" className="align-top mr6" color="color11" />
                        <Text size="xsm" fw="medium" color="color11">
                            {data}
                        </Text>
                    </div>
                );
        }
    };

    const fetchChargeConfigList = () => {
        setLoader(true);
        const successHandler = (res) => {
            setLoader(false);
            const list = res?.metaInfo?.data || [];
            setAllData(list);
            setData(list);
            setTotalPages(totalPages || 1);
        };

        const errorHandler = (err) => {
            setLoader(false);

            setMessage({
                success: "",
                error:
                    err?.response?.data?.message ||
                    "Failed to fetch transaction charges",
            });

            setAllData([]);
            setData([]);
        };

        const api = new Request("", successHandler, errorHandler, false);

        api.get(
            `${config.apis.admin.FETCH_TRANSACTION_CHARGES}?type=${activeTab}&page=${currentPage - 1}&size=${pageSize}`
        );
    };

    useEffect(() => {
        setCurrentPage(1);
        refreshPage();
        fetchChargeConfigList();
    }, [activeTab, currentPage, pageSize]);

    useEffect(() => {
        if (message.success || message.error) {
            const timer = setTimeout(() => {
                setMessage({ success: "", error: "" });
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [message]);

    const getColumnConfig = () => {
        const base = [
            { key: "applicableValue", label: activeTab },
            { key: "provider", label: "Provider" },
            { key: "transactionType", label: "Transaction Type" },
            { key: "paymentMode", label: "Payment Mode" },
            { key: "minAmount", label: "Min Amount" },
        ];

        if (activeTab === "BANK" || activeTab === "PG") {
            base.push({ key: "maxAmount", label: "Max Amount" });
        }

        if (activeTab === "BANK" || activeTab === "ROLE") {
            base.push({ key: "priority", label: "Priority" });
        }

        base.push(
            { key: "chargeType", label: "Charge Type" },
            { key: "chargeValue", label: "Charge Value" },
            { key: "gst", label: "GST" },
            { key: "status", label: "Status" },
            { key: "createdAt", label: "Created At" },
            { key: "action", label: "Update Status" },
        );

        return base;
    };

    const exportHeaders = getColumnConfig()
        .filter((col) => col.key !== "action")
        .map((col) => ({
            label: col.label,
            key: col.key,
        }));

    const pdfHeaders = [
        Object.fromEntries(
            getColumnConfig()
                .filter(col => col.key !== "action")
                .map(col => [col.key, col.label])
        )
    ];

    const updateStatus = (item) => {
        const newStatus = item.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
        setMessage({ success: "", error: "" });
        const successHandler = (res) => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMessage({ success: "Status updated successfully", error: "" });
            fetchChargeConfigList();
        };

        const errorHandler = (err) => {
            setLoader(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMessage({
                success: "",
                error:
                    err?.response?.data?.message ||
                    "Failed to fetch transaction charges",
            });

            setAllData([]);
            setData([]);
        };

        const api = new Request("", successHandler, errorHandler, false);

        api.post(
            `${config.apis.admin.UPDATE_STATUS_TRANSACTION_CHARGES}?uuid=${item.uuid}&status=${newStatus}`
        );
    };

    const onFilterChange = (event, index) => {
        const _controls = [...controls];
        let value;
        if (_controls[index].type === "select") {
            value = event;
        } else if (event?.target) {
            value = event.target.value;
        } else {
            value = event;
        }
        _controls[index].value = value;
        setControls(_controls);
    };

    const applyFilters = (e) => {
        if (e) e.preventDefault();

        const filtered = getFilteredData();

        setCurrentPage(1);
        setData(filtered);
    };

    const paginatedData = data;

    const refreshPage = () => {
        const resetControls = filterForm.map((item) => ({
            ...item,
            value: "",
        }));

        setControls(resetControls);
        setData(allData);
        setCurrentPage(1);
    };

    const getFilteredData = () => {
        let filtered = [...allData];

        const getValue = (name) => {
            const control = controls.find((c) => c.name === name);
            return control?.value ?? "";
        };

        const normalize = (v) =>
            (v || "").toString().toLowerCase().trim();

        const entity = normalize(getValue("entity"));
        const provider = normalize(getValue("provider"));
        const transactionType = normalize(getValue("transactionType"));
        const paymentMode = normalize(getValue("paymentMode"));

        const rawStatus = getValue("status");
        const status = rawStatus?.value || "";

        return filtered.filter((item) => {
            return (
                (!entity || normalize(item?.applicableValue).includes(entity)) &&
                (!provider || normalize(item?.provider).includes(provider)) &&
                (!transactionType || normalize(item?.transactionType).includes(transactionType)) &&
                (!paymentMode || normalize(item?.paymentMode).includes(paymentMode)) &&
                (!status || item?.status === status)
            );
        });
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize]);

    return (
        <>
            <div className="flex flex-center space-between mb10">
                <Heading size="xxl" color="color7">
                    Transaction Charges
                </Heading>

                <div className="flex flex-center">
                    <div className="mr20">
                        <CsvDown
                            headers={exportHeaders}
                            url={`${Config.apis.admin.FETCH_TRANSACTION_CHARGES}?type=${activeTab}&page=0&size=1000`}
                            title="CSV"
                            method="get"
                        />
                    </div>

                    <PdfDown
                        heading={`Transaction Charges - ${activeTab}`}
                        tableHeader={pdfHeaders}
                        getTableBody={getPdfBody}
                        url={`${Config.apis.admin.FETCH_TRANSACTION_CHARGES}?type=${activeTab}&page=0&size=1000`}
                        method="get"
                    />
                </div>
            </div>


            <ViewAdminWrapper>
                <FilterWrapper>
                    <FilterBox
                        filterForm={dynamicFilters}
                        onFilterChange={onFilterChange}
                        onFilterSubmit={(e) => {
                            e.preventDefault();
                            applyFilters();
                        }}
                        refreshPage={refreshPage}
                    />
                </FilterWrapper>
                {message.success && <SuccessMessage successMessage={message.success} />}
                {message.error && (
                    <ErrorMessage error={message.error} />
                )}
                <div className="tabs mb16" style={{ display: "flex", gap: "12px", marginTop: "0" }}>
                    {["ORG", "BANK", "PG", "ROLE"].map((tab) => {
                        const isActive = activeTab === tab;

                        return (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    transition: "all 0.2s ease",
                                    marginTop: "1rem",
                                    background: isActive ? "#ED141F" : "#FFFFFF",
                                    color: isActive ? "#fff" : "#333",

                                    boxShadow: isActive
                                        ? "0px 2px 6px rgba(237,20,31,0.3)"
                                        : "none"
                                }}
                            >
                                {tab}
                            </button>
                        );
                    })}
                </div>
                <TableWarpper className="mt24">
                    <table className="table" style={{ overflow: "auto" }}>
                        <thead>
                            <tr>
                                {getColumnConfig().map((col, i) => (
                                    <th key={i} style={{ whiteSpace: "nowrap" }}>
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {!loader && data.length ? (
                                paginatedData.map((item, idx) => (
                                    <tr key={idx} style={{ whiteSpace: "nowrap" }}>
                                        {getColumnConfig().map((col, i) => {
                                            switch (col.key) {
                                                case "chargeValue":
                                                    return (
                                                        <td key={i}>
                                                            {item?.chargeType === "PERCENTAGE"
                                                                ? `${item?.chargeValue}%`
                                                                : `₹ ${item?.chargeValue ?? 0}`}
                                                        </td>
                                                    );

                                                case "gst":
                                                    return (
                                                        <td key={i}>
                                                            {item?.gstApplicable
                                                                ? item?.gstType === "PERCENTAGE"
                                                                    ? `${item?.gstValue}%`
                                                                    : `₹ ${item?.gstValue ?? 0}`
                                                                : "No GST"}
                                                        </td>
                                                    );

                                                case "status":
                                                    return <td key={i}>{renderStatus(item?.status)}</td>;

                                                case "createdAt":
                                                    return (
                                                        <td key={i}>
                                                            {item?.createdAt
                                                                ? item.createdAt.split("T")[0]
                                                                : "-"}
                                                        </td>
                                                    );

                                                case "action":
                                                    return (
                                                        <td key={i}>
                                                            <BlockPayInWrapper style={{ display: "flex", justifyContent: "center" }}>
                                                                <div
                                                                    className="toggle-with-label flex flex-center space-between"
                                                                    style={{
                                                                        padding: 0,
                                                                        margin: 0,
                                                                        height: "17px",
                                                                        marginLeft: "5px",
                                                                        width: "40px",
                                                                    }}
                                                                >
                                                                    <label className="switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={item.status === "ACTIVE"}
                                                                            onChange={() => updateStatus(item)}
                                                                        />
                                                                        <span
                                                                            className="slider round"
                                                                            style={{
                                                                                cursor: "pointer",
                                                                            }}
                                                                        ></span>
                                                                    </label>
                                                                </div>
                                                            </BlockPayInWrapper>
                                                        </td>
                                                    );

                                                default:
                                                    return <td key={i}>{item?.[col.key] ?? "-"}</td>;
                                            }
                                        })}
                                    </tr>
                                ))
                            ) : (
                                !loader && (
                                    <tr>
                                        <td colSpan={getColumnConfig().length}>No records found</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </TableWarpper>

                <div className="mt24 flex flex-center">
                    <ItemPerPage pageSize={pageSize} getPageSize={setPageSize} />
                    {totalPages > 1 && (
                        <Pagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            getCurrentPageData={setCurrentPage}
                        />
                    )}
                </div>
            </ViewAdminWrapper >
        </>
    );
}
